import { useQuery } from '@tanstack/react-query'

const fetchDatasetAnalysis = async (datasetId, action, isSegment) => {
  const endpoint = isSegment
    ? `${process.env.REACT_APP_API_URL}/api/datasets/region-datasets/${datasetId}/analyze?action=${action}`
    : `${process.env.REACT_APP_API_URL}/api/datasets/${datasetId}/analyze?action=${action}`

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch dataset analysis')
  }

  return response.json()
}

const useDatasetAnalyze = (datasetId, action, updatedAt, isSegment = false) => {
  return useQuery({
    queryKey: ['datasetAnalysis', datasetId, action, updatedAt], // Add updatedAt to cache key
    queryFn: () => fetchDatasetAnalysis(datasetId, action, isSegment),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000, // cacheTime is now called gcTime in v5
    enabled: !!datasetId && !!action,
    retry: false,
  })
}

export default useDatasetAnalyze
